import { GetMatchResponse, PayloadAddMatch, PayloadConfirmBracketMatch, PayloadConfirmMatch } from '@/types/Match'
import { useMutation } from '@tanstack/react-query'
import httpService from './httpService'

export const enum MATCH_QUERY_KEY {
  GET_MATCH = 'get_match',
}

const addMatchPath = '/match/v1.0/save'
const deleteMatchPath = '/match/v1.0/delete'

export const useAddMatch = () => {
  return useMutation([], async (payload: PayloadAddMatch) => {
    const res = await httpService.Put(addMatchPath, payload)
    return res.result
  })
}

export const useClubAddMatch = () => {
  return useMutation([], async (payload: PayloadAddMatch) => {
    const { clubId, ...restPayload } = payload
    const res = await httpService.Put(`/club/${clubId}${addMatchPath}`, restPayload)
    return res.result
  })
}

export const useClubEditMatch = () => {
  return useMutation([], async (payload: PayloadAddMatch) => {
    const { clubId, ...restPayload } = payload
    const res = await httpService.Put(`/club/${clubId}/match/${restPayload.matchId}/v1.0/edit`, restPayload)
    return res.result
  })
}

export const useConfirmMatch = () => {
  return useMutation([], async (payload: PayloadConfirmMatch) => {
    const res = await httpService.Post(`/match/v1.0/confirm`, payload)
    return res
  })
}

// NOTE: Only use this API, dont confirm using normal player permission
export const useDirectorConfirmBracketMatch = () => {
  return useMutation([], async (payload: PayloadConfirmBracketMatch) => {
    const res = await httpService.Post(`/brackets/director/match/v1.0/confirm`, payload)
    return res
  })
}

export const useGetMatch = () => {
  return useMutation([], async (id: number) => {
    const res = await httpService.Get<GetMatchResponse>(`/match/${id}`)
    return res.result
  })
}

export const useDeleteMatch = () => {
  return useMutation([], async (id: number) => {
    const res = await httpService.Delete(`${deleteMatchPath}/${id}`)
    return res
  })
}
